import { CareersOffers } from "./components/CareersOffers";
import { NewsletterSection } from "../components/ui/NewsletterSection";

export const Careers = () => {
  return (
    <section className="careers-main">
      <CareersOffers />
      <NewsletterSection />
    </section>
  );
};
